import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { put, post, get } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function AddConsumptionByEquipment({
  inputData,
  fetchData,
  id,
  title,
  SelectedData,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: SelectedData?.consumptionPeriod?.month || "",
      year: SelectedData?.consumptionPeriod?.year || "",
    },
    equipment: SelectedData?.equipment?._id || "",
    vendor: SelectedData?.vendor?._id || "",
    brand: SelectedData?.brand || "",
    model: SelectedData?.model || "",
    usedHours: SelectedData?.usedHours || "",
    previousMeterReading: SelectedData?.previousMeterReading || "",
    currentMeterReading: SelectedData?.currentMeterReading || "",
    unitOfConsumption: SelectedData?.unitOfConsumption || "",
    remarks: SelectedData?.remarks || "",
    reasonForDeviation: SelectedData?.reasonForDeviation || "",
    documents: SelectedData?.documents || [],
    editRemarkReason: SelectedData?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState(initialState);

  useEffect(() => {
    // if (addData) {
    //   setFormData(initialState); // Reset form data when opening the drawer
    // }
    if (SelectedData) {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles(SelectedData.documents || []);
    } else if (!id) {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles([]);
    }
  }, [SelectedData]);

  // useEffect(() => {
  //   setFormData((prev) => {
  //     return {
  //       ...prev,
  //       unitOfConsumption: "",
  //       usedHours: "",
  //     };
  //   });
  // }, [formData?.equipment]);

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(SelectedData?.documents || []);
  };

  const fetchEquipmentOptions = async () => {
    try {
      const response = await get(`/master/Steam/Equipement`);
      setEquipmentOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching equipment options:", error);
    }
  };

  // Fetch options on component mount
  useEffect(() => {
    fetchEquipmentOptions();
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   console.log(name,value)
  //   setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  //   if (name.startsWith("calorificValue.")) {
  //     const key = name.split(".")[1];
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       calorificValue: {
  //         ...prevState.calorificValue,
  //         [key]: value,
  //       },
  //     }));

  //     setErrors((prevState) => ({
  //       ...prevState,
  //       calorificValue: {
  //         ...prevState.calorificValue,
  //         [key]: "",
  //       },
  //     }));
  //   }
  //     else if (name==="quantityConsumed") {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         quantityConsumed: {
  //           value: value,
  //         },}))
  //         setErrors((prevState) => ({
  //           ...prevState,
  //           quantityConsumed: "",
  //       }))
  //   } else {
  //     setFormData((prevState) => ({ ...prevState, [name]: value }));
  //   }
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   // Clear any existing errors for this field
  //   setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

  //   // Check if the selected field is "equipment"
  //   if (name === "equipment") {
  //     // Find the selected equipment details
  //     const selectedEquipment = equipmentOptions.find((item) => item._id === value);
  //     console.log(name,selectedEquipment, value,"Changing")
  //     // If equipment is found, set brand and model in formData
  //     if (selectedEquipment) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         equipment: value,
  //          brand: selectedEquipment.brand || "", // Autofill brand
  //          model: selectedEquipment.model || "", // Autofill model
  //         // unitOfConsumption: selectedEquipment.unit || "",
  //       }));
  //     }
  //   } else {
  //     // Default behavior for other fields
  //     setFormData((prevState) => ({ ...prevState, [name]: value }));
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear any existing errors for this field
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

    // Check if the selected field is "equipment"
    if (name === "equipment") {
      // Find the selected equipment details
      const selectedEquipment = equipmentOptions.find(
        (item) => item._id === value
      );
      console.log(name, selectedEquipment, value, "Changing");
      // If equipment is found, set brand and model in formData
      if (selectedEquipment) {
        setFormData((prevState) => ({
          ...prevState,
          equipment: value,
          brand: selectedEquipment.brand || "", // Autofill brand
          model: selectedEquipment.model || "", // Autofill model
          unitOfConsumption: "",
          usedHours: "",
          //  unitOfConsumption: selectedEquipment.ratedConsumption*value || "",
        }));
      }
    } else if (name === "usedHours") {
      const selectedEquipment = equipmentOptions.find(
        (item) => item._id === formData.equipment
      );
      const isValidPercentage = /^-?\d*(\.\d+)?$/.test(Number(value));
      const hours = isValidPercentage ? parseFloat(value) : 0;
      // const isValidNumber = /^-?\d+$/.test(value); // Check if value is a valid integer
      // const hours = isValidNumber ? parseInt(value, 10) : 0; // Parse value if valid, otherwise set to 0
      console.log(
        hours,
        selectedEquipment?.ratedConsumption * hours,
        selectedEquipment?.ratedConsumption,
        "Searching for Equipment in hours"
      );
      setFormData((prevState) => ({
        ...prevState,
        [name]: isValidPercentage ? value : "",
        unitOfConsumption:
          selectedEquipment && selectedEquipment.ratedConsumption
            ? selectedEquipment.ratedConsumption * hours
            : 0, // Calculate based on valid hours
      }));
    } else {
      // Default behavior for other fields
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleClose = () => {
    // setAddData(false);
    // setErrors({});
    // resetFrom();
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];
      console.log(value1, value2, "changed");
      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      // setAddData(false);
      // setErrors({});
      setEditDialog(true);
      // resetForm();
      // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      if (input.required && !value) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
      //   console.log(input.fieldName, uploadedFiles);
      //   newErrors[input.fieldName] = `Please upload Documents`;
      // }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };

    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.industrialEquipment;
    }
    delete dataToSend.vendor;

    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    // Remove fields that have empty values
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     dataToSend[key] === "" || // Empty strings
    //     (typeof dataToSend[key] === "object" &&
    //       Object.keys(dataToSend[key]).length === 0) // Empty objects
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });

    let method = SelectedData ? put : post;
    let url = SelectedData ? `${updateUrl}?Id=${SelectedData?._id}` : addUrl;
    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(initialState);
        setUploadedFiles([]);
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks" || el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.fieldName === "unitOfConsumption" && "KWH"} // Pass error prop
        // readOnly={["brand", "model"].includes(el.fieldName)}
        disabled={["brand", "model", "unitOfConsumption"].includes(
          el.fieldName
        )}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "400px", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {SelectedData !== null
            ? `Edit Consumption By Equipment`
            : `Add Consumption By Equipment`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddConsumptionByEquipment;
